import {useAtom} from "jotai";
import {SDrawerOrModal} from "shj-components";
import {CallModal} from "@/pages/callTool/intelligentOutboundCall/components/Info/CallModal.tsx";
import {callDataAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
import {useEffect} from "react";
import {SOFT_PHONE_EVENTS, triggerEvent, useSoftPhoneStore} from "@shj/use-soft-phone";

const ClueCallModal = (props) => {
  const {open, onClose, fn} = props;
  const [callData, setCallData] = useAtom(callDataAtom)
  const updateSoftPhoneAttr = useSoftPhoneStore(state => state?.updateSoftPhoneAttr)

  useEffect(() => {
    if(open) {
      setCallData((callData) => ({...callData, phone: ''}))
    }
    return () => {
      updateSoftPhoneAttr('extenType', "gateway")
      triggerEvent(SOFT_PHONE_EVENTS.SWITCH_EXTEN_TYPE, { extenType: "gateway" })
    }
  }, [open]);

  return <SDrawerOrModal
      title={' '}
      width={1050}
      open={open}
      onCancel={() => {
        onClose()
        fn()
      }}
      antdProps={{
        footer: null,
      }}
  >
    <CallModal clueId={props.clueId}/>
  </SDrawerOrModal>
}

export default ClueCallModal;